import {assignSafely, getSafely} from 'shared/web';

import {DrillDownLevelName} from '../../../types/api/drillDown';
import {VehicleFormType} from '../types/VehicleFormType';

const FILTER_ORDER: DrillDownLevelName[] = [
  'make',
  'model',
  'year',
  'fuel_type',
  'transmission',
  'drive',
  'power',
  'car_style',
];

export function getFiltersFromFormData(
  data: Partial<VehicleFormType>,
  stopAt: DrillDownLevelName = 'car_style'
): Partial<Record<DrillDownLevelName, string>> {
  const allFilters: Partial<Record<DrillDownLevelName, string>> = {
    make: data.make ?? undefined,
    model: data.modelFamily ?? undefined,
    year: data.firstRegistrationOnYear?.toString(),
    fuel_type: data.fuelType?.[0],
    transmission: data.transmission?.[0],
    drive: data.drive?.[0],
    power: data.power?.toString(),
    car_style: data.bodyStyle?.[0],
  };

  const stopAtIndex = FILTER_ORDER.indexOf(stopAt);
  if (stopAtIndex === -1) {
    return allFilters;
  }

  const keysToInclude = FILTER_ORDER.slice(0, stopAtIndex + 1);
  const result: Partial<Record<DrillDownLevelName, string>> = {};
  for (const key of keysToInclude) {
    assignSafely(result, key, getSafely(allFilters, key), {
      allowedKeys: [...FILTER_ORDER],
    });
  }
  return result;
}
